import { render } from "./SupportView.vue?vue&type=template&id=31c1e6c8"
import script from "./SupportView.vue?vue&type=script&lang=js"
export * from "./SupportView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__